import { useState } from 'react';
import PropTypes from 'prop-types';
import { Card } from '@mui/material';
import CustomTable from './Table';

const MembershipListResults = ({
  memberShipPlan = [],
  onEdit = () => {},
  onDelete = () => {},
  ...rest
}) => {
  const [page, setPage] = useState(0);

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  return (
    <Card {...rest}>
      <CustomTable
        data={memberShipPlan}
        dataKeysSequence={[
          'name',
          'amount',
          'duration',
          'description',
          'actions'
        ]}
        headers={['Name', 'Amount', 'Duration', 'Description', 'Actions']}
        handlePageChange={handlePageChange}
        page={page}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </Card>
  );
};

MembershipListResults.propTypes = {
  memberShipPlan: PropTypes.array.isRequired
};

export default MembershipListResults;
